// Configure the module IDs to page routes

export const pageRoutes: {
    [key: number]: string
} = {
    1: '/members',
    2: '/sports'
};
